<template>
  <div class="page-content">
    <div class="administrador-heading">
      <h5>{{ $t("lang.epc.epc-track") }}</h5>
    </div>
    <div class="epc-form">
      <h6>{{ $t("lang.epc.epc-find") }}</h6>
      <div class="centros-form">
        <form>
          <div class="form-row">
            <div class="col-md-6">
              <v-text-field
                :label="$t('lang.epc.epc')"
                outlined
                v-model="epc"
              ></v-text-field>
            </div>
            <div class="col-md-6">
            <v-btn
              color="#9ac31c"
              class="px-10"
              style="height: 55px"
              @click="submit"
              :loading="shouldLoading"
              :disabled="shouldLoading"
              >Submit</v-btn
            >
            </div>
        </div>

        </form>
      </div>
    </div>
    <div class="page-main-content">
      <div class="container-fluid">
            
        <div class="row">
          <bx-box
            :title="totalDevices + ' ' + $t('lang.epc.readings')"
            color="white"
            no-padding
            :loading="shouldLoading"
            class="col-12"
          >
            <template v-slot:default>
              <skeleton-table :columns="6" v-if="shouldLoading" />
              <bx-table
                :data="data"
                :columns="filteredHeaders"
                paginated
                v-if="!shouldLoading"
                :currentPage="page"
                :perPage="itemsPerPage"
                backendPagination
                :total="totalDevices"
                @update:currentPage="updatePage"
              >
                <template slot-scope="props">
                  <bx-table-column centered class="pt-5">{{
                    props.row.id
                  }}</bx-table-column>
                  <bx-table-column centered class="pt-5">{{
                    props.row.date
                  }}</bx-table-column>
                 <bx-table-column centered class="pt-5" v-if="props.row.state === 0">
                      STOCKED
                  </bx-table-column>
                  <bx-table-column centered class="pt-5" v-else-if="props.row.state === 1">
                      UNKNOW
                  </bx-table-column>
                 <bx-table-column centered class="pt-5" v-else-if="props.row.state === 2">
                      IN TRANSIT
                  </bx-table-column>
                  <bx-table-column centered class="pt-5" v-else-if="props.row.state === 3">
                      SOLD
                  </bx-table-column>
                  <bx-table-column centered class="pt-5">
                      {{props.row.area1.description}}-{{props.row.area1.location_description}}
                  </bx-table-column>
                  <bx-table-column centered class="pt-5" v-if="props.row.area2">
                      {{props.row.area2.description}}-{{props.row.area2.location_description}}
                  </bx-table-column>
                  <bx-table-column centered class="pt-5" v-else>
                      {{props.row.area2}}
                  </bx-table-column>
                  <bx-table-column centered class="pt-5">
                      {{props.row.readingSet}}
                  </bx-table-column>
                </template>
              </bx-table>
            </template>
          </bx-box>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "EPCDashboard",
  data() {
    return {
      errors: [],
      epc:"",
      shouldLoading: false,
      totalDevices: 0,
      data: [],
      columns : [
            {
              field: "id",
              label: this.$t("lang.epc.id"),
              centered: true,
              display: true
            },
            {
              field: "date",
              label: this.$t("lang.epc.date"),
              centered: true,
              display: true
            },
            {
              field: "state",
              label: this.$t("lang.epc.state"),
              centered: true,
              display: true
            },
            {
              field: "area1",
              label: this.$t("lang.epc.area_location"),
              centered: true,
              display: true
            },
            {
              field: "location",
              label: this.$t("lang.epc.area_location_destination"),
              centered: true,
              display: true
            },
            {
              field: "reading_set",
              label: this.$t("lang.epc.reading_set"),
              centered: true,
              display: true
            },

          ],
      itemsPerPage: process.env.VUE_APP_ITEMS_PER_PAGE,
      page: 1,
      success: {
        show: false,
        message: this.$t("lang.admin.printer_form.success_add_printer_order")
      },
      errorLabels: {
        failed: this.$t("lang.messages.label_something_went_wrong")
      }
    };
  },
  async mounted() {
    this.submit()
  },
    computed: {
    filteredHeaders() {
      if (this.columns) {
        return this.columns.filter(header => header.display === true);
      }
      return [];
    }
  },
  methods: {
    async submitForm() {

        this.companyFormat = await this.$api.printer.printer_tagtype({
          tag_type: this.selectedTag,
          tag_format: this.selectedTagFormat,
          limit: 10
        }); 
        try {
          const res = await this.$api.printer.printUploadedFileNEW(
                  this.companyFormat.results[0].id,
                  this.user.company,
                  this.file);
        } catch (error) {
          this.errors.push(this.errorLabels.failed);
          console.error(error);
        } finally {
          this.success.show = true;
        }
    },
    updatePage(p) {
      this.page = p;
      this.submit();
    },

    async submit() {
      try {
        this.item = await this.$api.epc.retrieve_epc({"epc":this.epc});
        if(this.item.length>0){
        let epcs = await this.$api.epc.item_stock(this.item[0].id, 
        { offset: (this.page - 1) * this.itemsPerPage,
          limit: this.itemsPerPage
        });
        this.data = epcs.results;
        this.totalDevices = epcs.count;
        }
      } catch (error) {
        console.error(error);
      } finally {
        setTimeout(() => {
          this.columns = [
            {
              field: "id",
              label: this.$t("lang.epc.id"),
              centered: true,
              display: true
            },
            {
              field: "date",
              label: this.$t("lang.epc.date"),
              centered: true,
              display: true
            },
            {
              field: "state",
              label: this.$t("lang.epc.state"),
              centered: true,
              display: true
            },
            {
              field: "area1",
              label: this.$t("lang.epc.area_location"),
              centered: true,
              display: true
            },
            {
              field: "location",
              label: this.$t("lang.epc.area_location_destination"),
              centered: true,
              display: true
            },
            {
              field: "reading_set",
              label: this.$t("lang.epc.reading_set"),
              centered: true,
              display: true
            },

          ];
          this.shouldLoading = false;
          this.selectedRecords = [];
          this.selectedRows = [];
        }, 100);
      }
    }
  }
};
</script>